import { getEnvironment, getParameterByName } from "../../utils";
import get from "lodash/get";
const log = console;
let trackingIdEntrada = "";
const postbacksPendientes = new Set();
const postbacksEnviados = new Set();

const obtenerTrackingId = () => {
  const trackingId = getParameterByName("tracking_id");
  return typeof trackingId === "string" ? trackingId.trim() : "";
};

const fueEnviado = key => {
  if (postbacksEnviados.has(key)) return true;
  try {
    return sessionStorage.getItem(key) === "success";
  } catch (error) {
    // El almacenamiento puede estar bloqueado; se conserva el control en memoria.
    log.warn("AlPrestamo: no se pudo consultar sessionStorage", error);
    return false;
  }
};

export default {
  enable() {},
  wait() {
    return true;
  },
  init() {
    // Conserva el tracking de entrada si desaparece durante la navegación interna.
    trackingIdEntrada = obtenerTrackingId();
  },
  async offered(context) {
    let key;
    let envioIniciado = false;
    try {
      // La elegibilidad se captura al hacer clic, antes de que cambie el loader.
      if (get(context, "mutation.payload.simulacionValida", false) !== true) {
        return;
      }

      const trackingId = obtenerTrackingId() || trackingIdEntrada;
      if (!trackingId) return;

      const environment = getEnvironment();
      const urlpostback =
        environment.name === "prod"
          ? "https://api.ar.alprestamo.io"
          : "https://sandbox.api.ar.alprestamo.io";
      key = `alprestamo:offered:${environment.name}:${trackingId}`;
      if (postbacksPendientes.has(key) || fueEnviado(key)) return;

      postbacksPendientes.add(key);
      envioIniciado = true;
      const url = new URL(`${urlpostback}/bid/postback/only-by-url`);
      url.searchParams.set("tracking_id", trackingId);
      url.searchParams.set("status", "offered");

      const response = await fetch(url.href, {
        method: "GET",
        keepalive: true
      });
      if (response.status !== 200) {
        throw new Error("Respuesta HTTP no exitosa del postback");
      }
      const data = await response.json();
      if (data.status !== "success") {
        throw new Error("Postback no confirmado por AlPrestamo");
      }

      postbacksEnviados.add(key);
      try {
        sessionStorage.setItem(key, "success");
      } catch (error) {
        // El envío confirmado también queda registrado en memoria.
        log.warn("AlPrestamo: no se pudo actualizar sessionStorage", error);
      }
    } catch (error) {
      log.error("AlPrestamo error", error);
    } finally {
      if (envioIniciado) postbacksPendientes.delete(key);
    }
  },
  async gracias(context) {
    const environment = getEnvironment();
    const urlpostback =
      environment.name === "prod"
        ? "https://api.ar.alprestamo.io"
        : "https://sandbox.api.ar.alprestamo.io";
    const tracking_id = getParameterByName("tracking_id");

    if (tracking_id) {
      try {
        const amount = get(
          context,
          "state.simulacion.resultado.multiplazoObj.montoMaximo",
          ""
        );
        const installments = get(
          context,
          "state.simulacion.resultado.multiplazoObj.cantidadCuotas",
          ""
        );

        const product =
          "prestamo personal-" + get(context, "state.userIdTokenizado", "");
        const response = await fetch(
          `${urlpostback}/bid/postback/only-by-url?tracking_id=${tracking_id}&status=granted&amount=${amount}&installments=${installments}&product=${encodeURIComponent(
            product
          )}`
        );
        await response.json();
      } catch (error) {
        log.error(`AlPrestamo error`, error);
      }
    }
  }
};
